<template>
    <div>
        <div style="display:flex; border-radius:20px; background-color:#F0EFEF;position:relative;" ref="tab_wrap">
            <div style="position:absolute; height:40px; border-radius:20px; background-color: black;z-index:0; transition: all 0.2s"
                 :style="{width: selected_area_width + 'px', left : selected_area_left + 'px'}">
            </div>
            <div v-for="each, i in tabs" :key="i"
                 style="flex:1; display:grid;place-items: center; height:40px; font-weight:bold; font-size:16px; padding:0px 20px; position:relative;z-index:1; white-space: nowrap;"
                 @click="() => {setTab(i); each.action(i);}"
                 :ref="'tab_' + i"
                 :style="{color : cur_tab === i ? 'white' : '#808080'}"
            >{{each.name}}</div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "SwitchTab",
        props : {
            tabs : {
                type : Array,
                default : () => []
            },
            initSetTabIndex: {
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                cur_tab : 0,
                selected_area_width : 0,
                selected_area_left : 0,
                // tabs : [
                //     {
                //         name : '테스트1',
                //         action : (index) => {
                //             console.log(`테스트 ${index} 누름`);
                //         }
                //     },
                //     {
                //         name : '테스트2',
                //         action : (index) => {
                //             console.log(`테스트 ${index} 누름`);
                //         }
                //     }
                // ]
            }
        },
        methods : {
            setTab(index){
                this.cur_tab = index;
                const tab_wrap_rect = this.$refs.tab_wrap.getBoundingClientRect();
                const tab_rect = this.$refs['tab_' + index][0].getBoundingClientRect();

                const left_diff = tab_rect.left - tab_wrap_rect.left;

                this.selected_area_left = left_diff;
                this.selected_area_width = tab_rect.width;
            }
        },
        mounted(){
            this.setTab(this.initSetTabIndex);
        }
    }
</script>

<style scoped>

</style>